<template>
  <div class="m-2">
    <div class="flex justify-center items-center">
      <div class="w-2/3">
        <div class="flex justify-between items-center">
          <div class="text-4xl text-black">
            {{ assignmentToDo.toDoItemName }}
          </div>
          <div class="flex flex-row justify-end sp-x-1">
            <div class="text-2xl">
              <span>({{ toDoFeedback.length }})</span>
            </div>
            <d-icon class="text-4xl" icon="comments" @click="launchToDoFeedbackSideDrawer()" />
          </div>
        </div>
        <div class="mb-5">
          <h5 class="text-black">
            Due Date: {{ assignmentToDo.toDoItemDueDate | formatShortDate }}
          </h5>
          <div class="text-xl mb-10 wysiwyg-editor-container" v-html="assignmentToDo.toDoItemHtmlContent" />

          <h4 class="mb-5 font-bold">
            Submission Content:
          </h4>
          <div class="text-xl mb-10 wysiwyg-editor-container" v-html="assignmentToDo.content" />
          <d-btn :loading="saving" @click="submitAssignmentForReview()">
            Mark As Completed
          </d-btn>
        </div>
      </div>

      </form>
    </div>
  </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import FeedbackSideDrawer from '../Assignments/components/FeedbackSideDrawer';

  export default {
    parent: true,
    props: {
      user: {
        type: Object,
        default: () => { },
      },
      toDoId: {
        type: Number,
        default: () => 0,
      },
    },

    data: () => ({
      assignmentToDo: '',
      toDoFeedback: [],
      loadingToDo: false,
      loadingFeedback: false,
      saving: false,
      assignmentToDoForm: {
        completed: false,
        submitted: false,
        content: '',
        userAssignmentId: 0,
        toDoItemTemplateId: 0,
      },
    }),

    mounted() {
      this.getAssignmentToDo();
      this.getToDoFeedback();
    },

    methods: {
      async getToDoFeedback() {
        this.loadingFeedback = true;
        try {
          const { data } = await axios.get(
            `/api/assignments/todos/${this.toDoId}/feedback`,
          );
          this.toDoFeedback = data;
          this.loadingFeedback = false;
        } catch (error) {
          this.$toast.open({
            message: error.message,
            color: 'red-500',
            duration: 4000,
          });
          this.loadingFeedback = false;
        }
      },

      async getAssignmentToDo() {
        this.loadingToDo = true;
        try {
          const { data } = await axios.get(
            `/api/user/to-dos/${this.toDoId}`,
          );
          this.assignmentToDo = data;
          this.loadingToDo = false;
        } catch (error) {
          this.$toast.open({
            message: error.message,
            color: 'red-500',
            duration: 4000,
          });
          this.loadingToDo = false;
        }
      },

      async submitAssignmentForReview() {
        this.assignmentToDoForm.completed = true;
        this.assignmentToDoForm.id = this.assignmentToDo.id;
        this.assignmentToDoForm.userId = this.assignmentToDo.userId;
        this.assignmentToDoForm.submitted = this.assignmentToDo.submitted;
        this.assignmentToDoForm.content = this.assignmentToDo.content;
        this.assignmentToDoForm.userAssignmentId = this.assignmentToDo.userAssignmentId;
        this.assignmentToDoForm.toDoItemTemplateId = this.assignmentToDo.toDoItemTemplateId;

        this.loading = true;

        try {
          await axios.patch(
            `/api/user/to-dos/${this.assignmentToDoForm.id}`, this.assignmentToDoForm,
          );
          this.getAssignmentToDo();
          this.$toast.open({
            message: `${this.assignmentToDo.toDoItemName} marked complete!`,
            color: 'green-500',
          });
          this.loading = false;
        } catch (error) {
          this.$toast.open({ message: error.message, color: 'red-500' });
          this.loading = false;
        }
      },

      launchToDoFeedbackSideDrawer() {
        this.$sideDrawer.open({
          parent: this,
          component: FeedbackSideDrawer,
          props: {
            entityId: Number(this.toDoId),
            user: this.user,
            type: 'ToDo',
          },
          events: {
            getToDoFeedback: () => this.getToDoFeedback(),
          },
        });
      },

    },
  };
</script>